module.exports = function () {
    $(document).ready(function () {

        var helper = require('./../../helper');

        // $('#show-ntq-document').on('show.bs.modal', function (e) {
        //
        //     $.ajax({
        //         type: 'GET',
        //         url: $(e.relatedTarget).data('path'),
        //         success: function (result) {
        //             $('#show-ntq-document iframe#ntq-document-body').html(result);
        //         }
        //     })
        // })
    });
}();
